import useHttpQuery from 'data/firestore/useHttpQuery';
import useDebouncedValue from 'hooks/useDebouncedValue';
import { ACTIONS_BASE_URL } from '../../../constants';
import { NexhealthPatientList } from '../types';

const getSearchParam = (search: string) => {
    if (!search) return '';
    if (/^[0-9]{10}$/.test(search)) return `&phoneNumber=${search}`;
    if (search.includes('@')) return `&email=${encodeURIComponent(search)}`;
    return `&name=${encodeURIComponent(search)}`;
};

const useNexhealthPatients = ({
    agentId,
    search,
    cursor,
    enabled = false,
}: {
    agentId: string;
    search: string;
    cursor?: string;
    enabled?: boolean;
}) => {
    const debouncedSearch = useDebouncedValue(search.trim());

    return useHttpQuery<NexhealthPatientList>({
        pathname: `/organizations/${agentId}/apps/nexhealth/patients?limit=25${getSearchParam(debouncedSearch)}${cursor ? `&cursor=${encodeURIComponent(cursor)}` : ''}`,
        server: ACTIONS_BASE_URL,
        key: ['nexhealth', 'patients', agentId, debouncedSearch, cursor],
        queryOptions: {
            enabled: Boolean(agentId) && enabled,
            retry: false,
            keepPreviousData: true,
        },
    });
};

export default useNexhealthPatients;
